import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ae8e05ac&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=ae8e05ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8e05ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae8e05ac')) {
      api.createRecord('ae8e05ac', component.options)
    } else {
      api.reload('ae8e05ac', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ae8e05ac&scoped=true&", function () {
      api.rerender('ae8e05ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logoConfig/index.vue"
export default component.exports